import { Card, Box, CardBody, CardFooter } from '@chakra-ui/react';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { RemoveItem } from 'shared-components';

interface IProps {
  name: string;
  type: string;
  isAgentLocked?: boolean;
  isRemovable?: boolean;
  removeOnClick?: () => void;
}

export const AgentRow = (props: IProps) => {
  const { name, type, isAgentLocked, isRemovable, removeOnClick } = props;

  return (
    <Card variant={'outline'} display={'flex'} flexDirection={'row'} mb={2}>
      <CardBody flexGrow={1} px={4} py={2}>
        {name}

        <Box as="span" color="muted">{` ${type}`}</Box>

        {isAgentLocked ? (
          <Box as="span" color="muted" ml={2}>
            <FontAwesomeIcon icon={faLock} />
          </Box>
        ) : null}
      </CardBody>

      {isRemovable ? (
        <CardFooter px={1} py={1}>
          <RemoveItem
            data-selector="remove-agent"
            size="sm"
            variant="ghost"
            label="Unassign agent"
            onClick={removeOnClick}
          />
        </CardFooter>
      ) : null}
    </Card>
  );
};
